import restClient, { ApiError, OAuthResponse } from '../RestClient';
import { GenerateResetTokenRequest, PasswordRecoveryRequest } from '@api/usersApi/types';

export const usersApi = {
    login: function (username: string, password: string): Promise<OAuthResponse | ApiError> {
        return restClient.login(username, password);
    },

    refreshToken: function (): Promise<OAuthResponse | null | ApiError> {
        return restClient.refreshToken();
    },

    getUserInfo: function () {
        return restClient.fetch({
            method: 'GET',
            path: `userInfo`,
        });
    },

    logout: function (): Promise<string> {
        return restClient.logout();
    },
    generateResetToken: function <T>({
        data,
        abortSignal,
    }: {
        data: GenerateResetTokenRequest;
        abortSignal: AbortSignal;
    }): Promise<T> {
        return restClient.fetch({
            method: 'GET',
            path: `services/replancity_UserAuthService/generateResetToken`,
            data,
            fetchOptions: {
                signal: abortSignal,
            },
            requiredToken: false,
        });
    },
    changeUserPassword: function <T>({
        data,
        abortSignal,
    }: {
        data: PasswordRecoveryRequest;
        abortSignal: AbortSignal;
    }): Promise<T> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_UserAuthService/changeUserPassword`,
            data,
            fetchOptions: {
                signal: abortSignal,
            },
            requiredToken: false,
        });
    },
};
